import { cloneElement } from "react";
import { isMatch, format as fnsFormat } from "date-fns";
import { CHIPS_PLACEHOLDER_SIZE } from "./constants";
export const handleLeadingZero = (value) => {
    const valueStr = String(value);
    return valueStr.length > 1 ? valueStr : `0${valueStr}`;
};
export const debounce = (fn, delay) => {
    if (typeof fn !== "function") {
        throw new TypeError("Expected a function");
    }
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
};
export function formatDate(d, format, withSeconds) {
    return fnsFormat(d, getFormatString(format, withSeconds));
}
export function prepareChipsToSimulateLoop(chips, placeholder) {
    const result = [...chips];
    if (chips.length < 4) {
        result.unshift(placeholder);
        result.unshift(placeholder);
        result.push(placeholder);
        result.push(placeholder);
        return result;
    }
    const preItems = result.slice(-CHIPS_PLACEHOLDER_SIZE);
    const postItems = result.slice(0, CHIPS_PLACEHOLDER_SIZE);
    result.unshift(...preItems.map((e, i) => cloneElement(e, {
        key: `clone-pre-${String(i)}`,
        "data-pre-chip-clone-index": i,
    })));
    result.push(...postItems.map((e, i) => cloneElement(e, {
        key: `clone-post-${String(i)}`,
        "data-post-chip-clone-index": i,
    })));
    return result;
}
export const isTimeStringValid = (value, format, withSeconds) => {
    const nextValue = value.replace(/\s/g, "").replace(/:/g, "");
    const formatString = getFormatString(format, withSeconds);
    return isMatch(nextValue.replace(/[a-z]/g, "0"), formatString);
};
export const isDateValid = (date) => {
    try {
        return isTimeStringValid(formatDate(date, "24", true), "24", true);
    }
    catch (error) {
        return false;
    }
};
export const getBeforeMaskedStateChangeHandler = (format, withSeconds) => ({ nextState, previousState }) => {
    // no input
    if (!previousState)
        return nextState;
    // delete last char
    if (nextState.enteredString === "")
        return nextState;
    const { value } = nextState;
    if (isTimeStringValid(value, format, withSeconds)) {
        return nextState;
    }
    return previousState;
};
function getFormatString(format, withSeconds) {
    let formatString = "hhmm";
    if (format === "24") {
        formatString = "HHmm";
    }
    if (withSeconds) {
        formatString = `${formatString}ss`;
    }
    return formatString;
}
export function initStringReplacer(replacement, maskPlaceholder, format, start, end) {
    return (str) => {
        return (str || maskPlaceholder)
            .replace(/:/g, "")
            .replace(/./g, (char, i) => i >= start && i < end ? replacement[i - start] : char)
            .replace(/[h,H,m,s]/g, (char, index) => {
            if (index < start) {
                if (index === 0) {
                    if (format === "12") {
                        return ("0" + (new Date().getHours() % 12 || 12)).slice(-2);
                    }
                    return ("0" + new Date().getHours()).slice(-2);
                }
                if (index === 2) {
                    return ("0" + new Date().getMinutes()).slice(-2);
                }
                return "";
            }
            return char;
        });
    };
}
